import { render, staticRenderFns } from "./ObjectHeader.vue?vue&type=template&id=65e89932"
import script from "./ObjectHeader.vue?vue&type=script&lang=js"
export * from "./ObjectHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports